import React from 'react';
import '../assets/css/header.css';
import logo from '../assets/gr/mdxpslogo.png'; // Updated logo path

const Header = () => {
    return (
        <header className="header">
            <div className="header-logo-container">
                <img src={logo} alt="Maryland Express Logo" className="header-logo" />
                <h1 className="header-title">Welcome to My100squares</h1>
            </div>
            <p className="header-subtitle">Support the Maryland Express Softball Team!</p>
        </header>
    );
};

export default Header;